export interface Organization {
  id: string;
  name: string;
  description?: string;
  status: 'active' | 'suspended' | 'inactive';
  memberCount: number;
  createdAt: string;
  updatedAt: string;
}

export const mockOrganizations: Organization[] = [
  {
    id: 'org-1',
    name: 'Tech Innovations Inc.',
    description: 'Leading technology solutions provider',
    status: 'active',
    memberCount: 25,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-15T00:00:00Z'
  },
  {
    id: 'org-2',
    name: 'Digital Marketing Agency',
    description: 'Full-service digital marketing solutions',
    status: 'active',
    memberCount: 12,
    createdAt: '2024-01-05T00:00:00Z',
    updatedAt: '2024-01-20T00:00:00Z'
  },
  {
    id: 'org-3',
    name: 'StartupCorp',
    description: 'Innovative startup in fintech space',
    status: 'active',
    memberCount: 8,
    createdAt: '2024-01-10T00:00:00Z',
    updatedAt: '2024-01-25T00:00:00Z'
  },
  {
    id: 'org-4',
    name: 'Enterprise Solutions Ltd.',
    description: 'Enterprise software development',
    status: 'suspended',
    memberCount: 45,
    createdAt: '2023-12-01T00:00:00Z',
    updatedAt: '2024-01-30T00:00:00Z'
  },
  {
    id: 'org-5',
    name: 'Creative Studio',
    description: 'Design and creative services',
    status: 'active',
    memberCount: 15,
    createdAt: '2024-01-12T00:00:00Z',
    updatedAt: '2024-01-28T00:00:00Z'
  }
];

export const findOrganizationById = (id: string): Organization | undefined => {
  return mockOrganizations.find(org => org.id === id);
};